import type { CPU } from '../CPU';
import { PSW_C } from './constants';

export function opSLL(cpu: CPU): void {
  cpu.impl_shift_buffer = 0;
  shiftLeft8(cpu);
}

export function opSLLC(cpu: CPU): void {
  const external_reg_index = (cpu.impl_operands[0].register_index - 1) & 15;
  cpu.impl_shift_buffer = cpu.regs.r[external_reg_index];
  shiftLeft8(cpu);
}

export function opSRA(cpu: CPU): void {
  const shift_by = cpu.impl_operands[1].value & 7;
  const msb = cpu.impl_operands[0].value & 0x80;
  cpu.impl_shift_buffer = 0;
  shiftRight8(cpu);
  if (msb)
    cpu.impl_operands[0].value |= (0xFF >> shift_by) ^ 0xFF;
}

export function opSRL(cpu: CPU): void {
  cpu.impl_shift_buffer = 0;
  shiftRight8(cpu);
}

export function opSRLC(cpu: CPU): void {
  const external_reg_index = (cpu.impl_operands[0].register_index + 1) & 15;
  cpu.impl_shift_buffer = cpu.regs.r[external_reg_index];
  shiftRight8(cpu);
}

export function shiftLeft8(cpu: CPU): void {
  cpu.impl_operands[0].value &= 0xFF;
  const shift_by = cpu.impl_operands[1].value & 7;
  const result = (cpu.impl_operands[0].value << shift_by) | (cpu.impl_shift_buffer >> (8 - shift_by));
  cpu.impl_flags_changed |= PSW_C;
  if (result & 0x100)
    cpu.impl_flags_out |= PSW_C;
  cpu.impl_operands[0].value = result & 0xFF;
}

export function shiftRight8(cpu: CPU): void {
  cpu.impl_operands[0].value &= 0xFF;
  const shift_by = cpu.impl_operands[1].value & 7;
  const result = (cpu.impl_operands[0].value << (8 - shift_by)) | (cpu.impl_shift_buffer << (16 - shift_by));
  cpu.impl_flags_changed |= PSW_C;
  if (result & 0x80)
    cpu.impl_flags_out |= PSW_C;
  cpu.impl_operands[0].value = (result >> 8) & 0xFF;
}
